import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const PaymentIdSchema = z.string().brand('payment-id')

export type PaymentId = ZodInfer<typeof PaymentIdSchema>

export const PaymentId = (
  value: string = generateRandomString()
): PaymentId => {
  return PaymentIdSchema.parse(value)
}
